<template>
  <div class="banner-full-width" :style="`background-image: url(${imageUrl})`">
    <div class="banner-full-width__content">
      <h2 class="title" v-html="title"></h2>
      <a class="form-button primary" :href="actionUrl" target="_blank">
        <span v-html="actionTitle"></span>
      </a>
    </div>
    <span class="banner-full-width__disclaimer">{{ disclaimer }}</span>
  </div>
</template>

<script>
export default {
  name: 'banner-full-width',
  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    disclaimer: {
      type: String,
      required: true,
    },
    actionTitle: {
      type: String,
      required: true,
    },
    actionUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
